import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import { QUICK_REF } from './sprintsData';

const QuickRef = () => {
  return (
    <section id="quickref" className={styles.mint}>
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Every project <span className={styles.g}>on one page.</span>
        </h2>
        <p className={styles.secSub}>
          Ten mini projects, six guided production projects, your capstone — and four optional
          self-builds. Click a name for the full explanation.
        </p>
        <div className={styles.tscroll}>
          <table className={styles.qr}>
            <tbody>
              <tr>
                <th>#</th>
                <th>Project</th>
                <th>In one line</th>
                <th>Skill it proves</th>
              </tr>
              {QUICK_REF.map((p) => (
                <tr key={p.code}>
                  <td>{p.code}</td>
                  <td>{p.noLink ? p.name : <a href={`#${p.id}`}>{p.name}</a>}</td>
                  <td>{p.oneLiner}</td>
                  <td>{p.skill}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default QuickRef;
